/**
 * Kenzu Final CTA
 * Shopify 2.0
 */

(() => {
  "use strict";

  const SELECTOR = "[data-kenzu-final-cta]";
  const instances = new WeakMap();

  class KenzuFinalCTA {
    constructor(section) {
      this.section = section;
      this.observer = null;
      this.init();
    }

    init() {
      const reducedMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)"
      ).matches;

      if (
        reducedMotion ||
        !("IntersectionObserver" in window)
      ) {
        this.section.classList.add("is-visible");
        return;
      }

      this.observer = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;

            this.section.classList.add("is-visible");
            observer.unobserve(entry.target);
          });
        },
        {
          threshold: 0.15,
          rootMargin: "0px 0px -8% 0px"
        }
      );

      this.observer.observe(this.section);
    }

    destroy() {
      this.observer?.disconnect();
    }
  }

  const initialize = (root = document) => {
    const sections = [];

    if (
      root instanceof HTMLElement &&
      root.matches(SELECTOR)
    ) {
      sections.push(root);
    }

    root.querySelectorAll?.(SELECTOR).forEach((section) => {
      sections.push(section);
    });

    sections.forEach((section) => {
      if (instances.has(section)) return;

      instances.set(section, new KenzuFinalCTA(section));
    });
  };

  const destroy = (root) => {
    const sections = [];

    if (
      root instanceof HTMLElement &&
      root.matches(SELECTOR)
    ) {
      sections.push(root);
    }

    root.querySelectorAll?.(SELECTOR).forEach((section) => {
      sections.push(section);
    });

    sections.forEach((section) => {
      instances.get(section)?.destroy();
      instances.delete(section);
    });
  };

  const boot = () => initialize(document);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, {
      once: true
    });
  } else {
    boot();
  }

  document.addEventListener(
    "shopify:section:load",
    (event) => initialize(event.target)
  );

  document.addEventListener(
    "shopify:section:unload",
    (event) => destroy(event.target)
  );

  document.addEventListener(
    "shopify:section:select",
    (event) => {
      const section =
        event.target.matches?.(SELECTOR)
          ? event.target
          : event.target.querySelector?.(SELECTOR);

      section?.classList.add("is-visible");
    }
  );
})();